import { render, staticRenderFns } from "./RoleStatusesTable.vue?vue&type=template&id=2b020212&scoped=true&"
import script from "./RoleStatusesTable.vue?vue&type=script&lang=js&"
export * from "./RoleStatusesTable.vue?vue&type=script&lang=js&"
import style0 from "./RoleStatusesTable.vue?vue&type=style&index=0&id=2b020212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b020212",
  null
  
)

export default component.exports